<!-- <div class="main-wrapper">
    <app-header></app-header>
    <div class="app-body position-relative">
        <app-sidebar></app-sidebar>
        <main class="main">
            <div class="row">
              <div class="col-md-12">
                <div class="divider-top">
                  <div class="card card-accent-primary">
                    <div class="card-header account-detail-head">Password Change History</div>
                    <div class="card-body account-stat-body">
                      <div class="row">
                        <div class="col-md-12">
                            <div class="table-responsive">
                                <table class="row-border hover" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
                                  <thead>
                                    <tr class="text-center">
                                      <th>Date/Time</th>
                                      <th>Remark</th>
                                    </tr>
                                  </thead>
                                  <tbody *ngIf="historyData?.length != 0">
                                    <tr *ngFor="let data of historyData;let i = index;" style="text-align: center;">
                                        <td>{{data?.createdAt | date :'dd-MM-yyyy hh:mm:ss aa'}}</td>
                                        <td>{{data?.comment}}</td>
                                    </tr>
                                  </tbody>
                                  <tbody *ngIf="historyData?.length == 0">
                                    <tr>
                                      <td class="no-data-available" colspan="3">No data!</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </main>
        <app-right-sidebar></app-right-sidebar>              
    </div>
  <app-footer-main></app-footer-main>
</div> -->

<div class="app-body">
    <app-header></app-header>
      <div class="full-wrap">
        <div class="col-left">
          <div class="sub_path">
            <div class="path">
              <a href="#path-pop" class="path-back">...</a>
              <ul>
                <li class="path-last"><a href="#">My Account</a></li>
              </ul>
            </div>
            <ul class="menu-list" data-widget="tree">
                <li>
                  <a (click)="info()" class="select">
                    <span>My Profile</span><span class="pull-right-container"></span>
                  </a>
                </li>
                <li>
                  <a (click)="rollComission()">
                    <span>Rolling Commision</span><span class="pull-right-container"></span>
                  </a>
                </li>
                <li>
                  <a (click)="statement()">
                    <span>Account Statement</span><span class="pull-right-container"></span>
                  </a>
                </li>
                <li>
                  <a [routerLink]="['/betHistory']">
                    <span>Bets History</span><span class="pull-right-container"></span>
                  </a>
                </li>
                <li>
                  <a (click)="profitLoss()">
                    <span>Profit & Loss</span><span class="pull-right-container"></span>
                  </a>
                </li>
                <li>
                  <a (click)="historydiv()">
                    <span>Password History</span><span class="pull-right-container"></span>
                  </a>
                </li>
                <li>
                  <a (click)="activity()">
                    <span>Activity Log</span><span class="pull-right-container"></span>
                  </a>
                </li>
            </ul>
          </div>
        </div>
  
        <div id="centerColumn" class="col-center report">
          <!-- Loading Wrap -->
          <div id="loading" class="loading-wrap" style="top: 100px; display: none;">
              <ul class="loading">
                  <li><img src="assets/sky_img/loading40.gif"></li>
                  <li>Loading...
                  </li>
                  <br>
                  <li><span id="progress"></span></li>
              </ul>
          </div>
          
          <h2>Password Change History</h2>
          <div class="card-body account-stat-body">
            <div class="row">
              <div class="col-md-12">
                  <div class="table-responsive">
                      <table class="row-border hover" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
                        <thead>
                          <tr class="text-center">
                            <th>Date/Time</th>
                            <th>Remark</th>
                          </tr>
                        </thead>
                        <tbody *ngIf="historyData?.length != 0">
                          <tr *ngFor="let data of historyData;let i = index;" style="text-align: center;">
                              <td>{{data?.createdAt | date :'dd-MM-yyyy hh:mm:ss aa'}}</td>
                              <td>{{data?.comment}}</td>
                          </tr>
                        </tbody>
                        <tbody *ngIf="historyData?.length == 0">
                          <tr>
                            <td class="no-data-available" colspan="3">No data!</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </div>
  
<app-footer-main></app-footer-main>